import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PlatformLocation } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  isNavbarCollapsed = true;
  constructor(
    private router: Router,
    private location: PlatformLocation,
    private modalService: NgbModal

  ) {}

  ngOnInit() {

  }

  showModal(content) {
    this.modalService.open(content, { size: 'lg' });
    // $('#readmeModal').modal('show');
  }

}
